const STORAGE_KEY = 'trueimpact.dismissedReportTasks';

// Stored shape: { [programDbId]: { [year]: true } }
type DismissedMap = Record<string, Record<string, true>>;

const readMap = (): DismissedMap => {
  if (typeof window === 'undefined' || !window.localStorage) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed))
      return {};
    return parsed as DismissedMap;
  } catch {
    return {};
  }
};

const writeMap = (map: DismissedMap): void => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore quota / access errors
  }
};

export const getDismissedReportTasks = (): DismissedMap => readMap();

export const isReportTaskDismissed = (
  programDbId: number | string,
  year: number,
): boolean => readMap()[String(programDbId)]?.[String(year)] === true;

export const dismissReportTask = (
  programDbId: number | string,
  year: number,
): void => {
  const map = readMap();
  const pid = String(programDbId);
  const y = String(year);
  map[pid] = { ...(map[pid] || {}), [y]: true };
  writeMap(map);
};

export const unDismissReportTask = (
  programDbId: number | string,
  year: number,
): void => {
  const map = readMap();
  const pid = String(programDbId);
  if (!map[pid]) return;
  delete map[pid][String(year)];
  if (Object.keys(map[pid]).length === 0) delete map[pid];
  writeMap(map);
};

export const clearDismissedReportTasks = (): void => {
  writeMap({});
};
